module.exports = __webpack_public_path__ + "media/placeholder-images/placeholder_2-7d9097af.jpg";